import { requiredStrategy } from '../core';
import { creditCardExpireDateFormatStrategy } from './credit-card-expire-date-format-strategy';

export const creditCardExpireDateStrategy = (value: string) => {
  return creditCardExpireDateFormatStrategy(value) && requiredStrategy(value);
};
